import { useNavigate } from "react-router-dom";
import Button from "src/components/Button";
import DropdownButton from "src/components/DropdownButton";
import Loader from "src/components/Loader";
import withTranslation, {
	Translation,
} from "src/components/hoc/withTranslation";
import PublishTaskButton from "src/components/tasks/PublishTaskButton";
import useTaskForm from "src/hooks/api/tasks/useTaskForm";
import useWindowSize from "src/hooks/useWindowSize";

interface TaskModalActionsProps extends Translation {
	onClose?: () => void;
}

const TaskModalActions = ({ t, onClose }: TaskModalActionsProps) => {
	const { status, task, actions } = useTaskForm();
	const { isPhone } = useWindowSize();
	const navigate = useNavigate();
	const iconButtonClassName = "w-[40px] h-[40px] text-[20px]";

	return (
		<div className="flex items-center gap-3">
			{task?.hid && (
				<>
					{!isPhone && (
						<>
							<PublishTaskButton
								id={task.hid}
								variant="button"
								button={{ small: true }}
							/>

							<Button
								onClick={() => {
									if (status === "idle") {
										actions.save({
											disableAlert: true,
											forceSave: true,
										});
									}
								}}
								className="w-[40px] h-[40px]"
								tabIndex="-1"
								type="primary"
								iconOnly
								small
							>
								{["updating", "creating"].includes(status) ? (
									<Loader />
								) : (
									<i className="far fa-save"></i>
								)}
							</Button>

							<Button
								onClick={() => {
									navigate(`/tasks/${task.hid}/editor`);
								}}
								className="w-[40px] h-[40px]"
								tabIndex="-1"
								type="gray"
								iconOnly
								small
							>
								<i className="far fa-eye"></i>
							</Button>
						</>
					)}
					<DropdownButton
						menu={{
							position: "bottom-right",
						}}
						button={{
							tabIndex: "-1",
							children: <i className="far fa-ellipsis-v " />,
							iconOnly: true,
							className: iconButtonClassName,
							type: "gray",
							small: true,
						}}
					>
						{isPhone && (
							<>
								<PublishTaskButton
									id={task.hid}
									variant="dropdown-button"
								/>
							</>
						)}
						<DropdownButton.Item
							icon="far fa-eye"
							onClick={() => {
								navigate(`/tasks/${task.hid}/editor`);
							}}
						>
							{t("preview")}
						</DropdownButton.Item>
						<DropdownButton.Item
							loading={status === "duplicating"}
							icon="far fa-copy"
							onClick={() => {
								// setStatus("duplicating");
								actions.duplicate(task.id).then(() => {
									if (onClose) {
										onClose();
									}
									actions.clear();
								});
							}}
						>
							{t("duplicate")}
						</DropdownButton.Item>
						<DropdownButton.Item
							loading={status === "deleting"}
							icon="far fa-archive"
							onClick={() =>
								actions.archive(task.id).then(() => {
									if (onClose) {
										onClose();
									}
									actions.clear();
								})
							}
						>
							{t("archive")}
						</DropdownButton.Item>
					</DropdownButton>
				</>
			)}

			{onClose && (
				<Button
					tabIndex="-1"
					type="transparent"
					iconOnly
					className={iconButtonClassName}
					onClick={onClose}
					small
				>
					<i className="fal fa-times text-placeholder text-2xl"></i>
				</Button>
			)}
		</div>
	);
};

TaskModalActions.locale = {
	nl: {
		preview: "Preview",

		publish: "Uitbesteden",
		archive: "Archiveren",
		duplicate: "Dupliceren",
	},
	en: {
		preview: "Preview",

		publish: "Outsource",
		archive: "Archive",
		duplicate: "Duplicate",
	},
};

export default withTranslation(TaskModalActions);
